import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { User } from 'firebase';
import { AuthService } from 'src/app/services/auth.service';
import { Question } from 'src/app/models/question.model';

@Component({
  selector: 'app-quiz-history',
  templateUrl: './quiz-history.component.html',
  styleUrls: ['./quiz-history.component.css']
})
export class QuizHistoryComponent implements OnInit {

  @Input() lessonId:string = ''
  @Input() startGetData:boolean = false
  @Output() onBackCallback:EventEmitter<any> = new EventEmitter()

  history:any

  questions:Question[] = []

  constructor(
    private firestore:AngularFirestore,
    private authService:AuthService
  ) { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.startGetData.currentValue){
      this.getHistory()
    }
  }

  onBack(){
    this.onBackCallback.emit()
  }

  async getHistory(){
  
    var uid: string
    const user:User = await this.authService.checkAuth().then(result=>{
      return result
    })
    if (user) {
      uid = user.uid;
    }
    console.log(this.lessonId)
    console.log(uid)
    this.firestore.collection('quiz-histories').doc(uid).collection('lessons').doc(this.lessonId).get()
      .subscribe(queriedItem => {  
       this.history = queriedItem.data()
       this.questions = this.history.questions
      })
  }


}


